
import { ApiProperty } from "@nestjs/swagger";


export class DeptRequest {
    @ApiProperty()
    deptId: number;


    constructor(deptId: number) {
        this.deptId = deptId;
    }
}